module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-4th@2x-0ce61d1fb3e15ea30a3971b2e04bfd9a.png";